import React from "react";

// Simple slow-moving editorial marquee. Pure CSS — no library needed.
const Marquee = ({ items = [] }) => {
  const doubled = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-[#2C2621]/10 bg-[#F2EBE1]/60 py-6"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {doubled.map((it, i) => (
          <span
            key={`marquee-${i}-${typeof it === "string" ? it.slice(0, 20) : ""}`}
            className="font-serif-x text-2xl md:text-3xl text-[#2C2621] px-10 italic"
          >
            {it}
            <span className="mx-6 text-[#C16542]">·</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
